export const useRunStatus = (requestState) => {
    const processing = ["queued", "in_progress"].includes(requestState?.status);
    const status = processing ? "Thinking ..." : undefined;
    return { status, processing };
};
